import { useMemo } from 'react';

/**
 * Custom hook to safely retrieve and parse referral provider data from localStorage
 * @returns {Object} An object containing:
 *   - referralProviderData: The parsed data object from localStorage (or null)
 *   - referralProvider: The user object from the parsed data (or null)
 */
const useReferralProviderData = () =>
  useMemo(() => {
    try {
      const referralProviderDataString = localStorage.getItem('referralProviderData');

      if (!referralProviderDataString) {
        return {
          referralProviderData: null,
          referralProvider: null,
        };
      }

      const referralProviderData = JSON.parse(referralProviderDataString);
      const referralProvider = referralProviderData || null;

      return {
        referralProviderData,
        referralProvider,
      };
    } catch (error) {
      // Error parsing referral provider data from localStorage
      return {
        referralProviderData: null,
        referralProvider: null,
      };
    }
  }, []);

export default useReferralProviderData;
